export default __webpack_public_path__ + "static/media/Stamp5.a05cd9e3.svg";